export default {
  apiVersion: 'v2022-05-01',
  dataset: 'production',
  projectId: '7m88emnx',
  useCdn: true,
};
